"use strict";

exports.__esModule = true;
var _AboutPanel = require("./AboutPanel");
Object.keys(_AboutPanel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AboutPanel[key]) return;
  exports[key] = _AboutPanel[key];
});